import constants from '../constants/index';
import normalize from '../lib/normalize';

const defaultState = normalize({
	loading: true,
	school: null,
	term: null,
	schedule: null,
	selected: []
});

export default function schedulesReducer(state = defaultState, action) {
	let newState = state;

	switch(action.type) {
		case constants.REQUEST_SCHEDULES:

			newState = Object.assign({}, newState, {
				school: action.payload.school,
				term: action.payload.term
			});
			break;

		case constants.REQUEST_SCHEDULES_SUCCESS:
			newState = normalize(state, action.payload.schedules);
			break;
			
		case constants.REQUEST_SCHEDULE_SUCCESS:
			newState = Object.assign({}, newState, {
				schedule: action.payload.schedule.id,
				selected: [action.payload.schedule.id],
				loading: false
			});
			break;
		default:
	}

	if(!newState.schedule && newState.items.length > 0) {
		newState.schedule = newState.items[0];
	}
	return newState;
};


/** WEBPACK FOOTER **
 ** ./src/js/reducers/schedules_reducer.js
 **/